import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

interface Props {
  open: any,
  setOpen: any,
  fileType: any,
  fileToShow: any,
  setFileToShow: any,
  setFileType: any,
}
export const ImagePreviewModal: React.FC<Props> = ({ open, setOpen, fileType, fileToShow, setFileToShow, setFileType }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          overflow: "scroll",
          transform: "translate(-50%, -50%)",
          width: fileType === "pdf" ? "70%" :" 90%",
          bgcolor: "background.paper",
          maxHeight: "800px",
          boxShadow: 24,
          borderRadius: 5,
          p: 2,
        }}
      >
        {fileToShow && fileType !== "pdf" && (
          <img src={fileToShow} alt="Preview" width="100%" height="100%" />
        )}
        {fileToShow && fileType === "pdf" && (
          <embed
            src={fileToShow}
            width="100%"
            height="600px"
            type="application/pdf"
          />
        )}
      </Box>
    </Modal>
  );
};